import React from "react";
import confirmDelete from "../../assets/Images/confirm delete.png";
import { ReactComponent as Cancel } from '../../assets/Icons/Cancel.svg';
import { toast } from 'react-toastify';
import { axiosPostApi } from '../../helpers/interceptorServices';
import { apiList } from '../../helpers/apiList';
import CustomAlert from '../../helpers/CustomAlert';

const DeleteConfirmationRetailer = ({ isOpen, onClose, editData, fetchRetailerData, handleClose }) => {

  const deleteRetailer = () => {
    const loggedInUserName = sessionStorage.getItem('username');
    const requestBody = {
      ...editData,
      username: loggedInUserName,
      status: '3'
    };

    axiosPostApi(apiList.DELETE_RETAILER_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === '00') {
          toast.success("Retailer deleted successfully!");
          onClose();
          handleClose();
          fetchRetailerData(1);
        } else {
          CustomAlert({
            title: "Failed to delete retailer",
            text: response.data?.message || 'Invalid credentials. Please try again!',
            icon: 'error',
            confirmButtonText: 'Retry'
          });
          onClose();
          handleClose();
        }
      })
      .catch((error) => {       
        console.error("Error deleting retailer", error);
        toast.error("Failed to delete retailer.");
      });
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal fade show" style={{ display: "block", backgroundColor: 'rgba(0, 0, 0, 0.5)', margin: 0 }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header" style={{ borderBottom: "none" }}>
            <span style={{ marginLeft: 'auto' }} >
              <Cancel onClick={onClose} />
            </span>
          </div>
          <div className="modal-body text-center">
            <img src={confirmDelete} alt="Warning" className="img-fluid mb-3" style={{ width: '250px' }} />
            <h5 className="modal-title">Confirm Deletion?</h5>
            <p className="mt-2">Information will be permanently erased and irretrievable.</p>
          </div>
          <div className="modal-footer justify-content-center">
            <button
              type="button"
              className="btn btn-back"
              data-bs-dismiss="modal"
              onClick={onClose}
            >
              Cancel
            </button>
            <button type="button" className="btn btn-danger" onClick={deleteRetailer}>
              Delete Permanently
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationRetailer;
